module.exports = __webpack_public_path__ + "static/media/abbe_happy.cb07a540.png";